import browserUpdate from "browser-update";
import "./polyfills";

import "bootstrap-select/dist/css/bootstrap-select.min.css";

import { DataEntry } from "./data_entry.js";
import { Menu } from "./menu.js";

$(() => {
  const dataEntry = new DataEntry();
  dataEntry.addSessionTimer();

  const menu = new Menu(dataEntry);
  menu.init();

  const messages = document.querySelectorAll("#messages .message");
  if (messages) {
    messages.forEach((el) => {
      const message = dataEntry.translate(el.innerHTML);
      dataEntry.showMessage(el.dataset.level, message);
    });
  }

  const resize = () => {
    const content = document.querySelector(".page-content");
    if (content) {
      content.style.height = window.innerHeight + "px";
    }
  };
  window.addEventListener("resize", resize);
  resize();

  browserUpdate({
    test: false,
    required: { e: -4, f: -3, o: -3, s: -1, c: -3 },
    insecure: true,
    unsupported: true,
    api: "2021.10",
    reminder: 24,
    reminderClosed: 24,
    text: {
      msg: dataEntry.translate("warning.browser.update.msg"),
      msgmore: dataEntry.translate("warning.browser.update.msgmore"),
      bupdate: dataEntry.translate("warning.browser.update.bupdate"),
      bignore: dataEntry.translate("warning.browser.update.bignore"),
      remind: dataEntry.translate("warning.browser.update.remind"),
      bnever: dataEntry.translate("warning.browser.update.bnever"),
    },
  });
});
